import { NavigationSearch } from "@greco/components";

import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useSelector } from "../../../store/hooks";
import { setSearchRecommendations } from "../../../store/recommendations-page/recommendationsPage";
import { AppDispatch } from "../../../store/store";

export const SearchRecommendations = () => {
  const search = useSelector((s) => s.recommendationsPage.search);
  const dispatch: AppDispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <NavigationSearch
      value={search}
      placeholder={t("ram.clientsList.search")}
      onChange={(val) => {
        dispatch(setSearchRecommendations(val));
      }}
    />
  );
};
